import * as queries from '@supabase/queries';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MakeOptional, QuestionBank } from "../../../lib/supabase/types";




export function useAddBankQuestions() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["add-bank-question"],
        mutationFn: async (questions: Omit<MakeOptional<QuestionBank>, 'id' | 'created_at' | 'archived'>[]) => {
            const res = await queries.addQuestionsToQuestionBank(questions);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["template-questions"] });
            queryClient.invalidateQueries({ queryKey: ["bank-questions"] });
        }
    });
}

